// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_3ftFgprY","content":"_1Q4G_gYm","cards-container":"_1-DlLPeA","challenge-container":"_375rrT14"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/LargeGrid/LargeGrid.styl
// module id = 247
// module chunks = 0